import React from 'react';
import { Space, Table } from 'antd';
import { CoaRecord, CoaTableProps } from './type';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';

const { Column } = Table;

const CoaTable: React.FC<CoaTableProps> = (props) => {
	const {
		data,
		loading,
		totalRecords,
		currentPage,
		paginationChangeHandler,
		onEdit,
		onDelete,
	} = props;

	return (
		<div className={styles['dynamic-table']}>
			<Table<CoaRecord>
				dataSource={data}
				loading={loading}
				rowKey="id"
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					onChange: paginationChangeHandler,
					defaultPageSize: 10,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
			>
				<Column
					title="Account Number"
					dataIndex="accountNo"
					key="accountNo"
					className="bg-white"
				/>
				<Column
					title="COA Name"
					dataIndex="name"
					key="name"
					className="bg-white"
				/>
				<Column title="Type" dataIndex="type" key="type" className="bg-white" />
				<Column
					title="Description"
					dataIndex="desc"
					key="desc"
					className="bg-white"
					render={(text: string) => <span>{text || '-'}</span>}
				/>
				<Column
					title="Action"
					key="action"
					className="bg-white"
					render={(_: unknown, record: CoaRecord) => (
						<Space size={20}>
							<div
								className="cursor-pointer flex align-center justify-center"
								onClick={() => onEdit(record)}
							>
								<EditActionSvg />
							</div>
							<div
								className="cursor-pointer flex align-center justify-center"
								onClick={() => onDelete(record)}
							>
								<DeleteActionSvg />
							</div>
						</Space>
					)}
				/>
			</Table>
		</div>
	);
};

export default CoaTable;
